const darkTheme = {
    label: "Dark",
    background: "black",
    title: '#4eb1ff',
    typeBoxText: 'grey',
    stats: 'green'
}

const lightTheme = {
    label: 'Light',
    background: 'white',
    title: '#fd4e89',
    typeBoxText: 'grey',
    stats: 'blue'
}

const material = {
    label: 'Luna',
    background: '#18272f',
    title: '#ffffff',
    typeBoxText: '#5A3A7E',
    stats: '#F67599'
}

export const themeOptions = [
    {value: darkTheme, label: 'Dark'},
    {value: lightTheme, label: 'Light'},
    {value: material, label: 'Material'}
];